import React, { useContext } from 'react';
import { MetadataContext } from '@/components';
import { ExpertModel, LinkModel, ModuleBaseModel, ModuleBasePropsModel } from '@/types';
import ExpertElementApp from './ExpertElementApp';
import ExpertElementPublic from './ExpertElementPublic';

export type ExpertElementModel = ModuleBaseModel<
  { breadcrumb?: LinkModel[]; name?: string } & ExpertModel & ModuleBasePropsModel
>;

const ExpertElement = (data: ExpertElementModel) => {
  const { isPublic } = useContext(MetadataContext);

  return isPublic ? <ExpertElementPublic {...data} /> : <ExpertElementApp {...data} />;
};

export default ExpertElement;
